import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  JbFormFieldContainerModule,
  JbInputModule,
} from 'jb-component-library';

import { PromoCodeV2Component } from './promo-code-v2.component';

const MODULES = [
  ReactiveFormsModule,
  JbFormFieldContainerModule,
  JbInputModule,
];

const DECLARATIONS = [PromoCodeV2Component];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class PromoCodeV2Module {}
